
<template>
    <div class="home">
        <transition
            leave-active-class="opacityOut"
            enter-active-class="opacityIn"
            mode="out-in"
            appear
        >
            <router-view ref="main" />
        </transition>
    </div>
</template>

<script>
export default {
    name: "Home",
    components: {
    },
    methods: {},
    mounted() {
    },
};
</script>
<style lang="scss">
</style>
